import {computed, defineComponent, onMounted, onBeforeMount, ref} from 'vue';

export default defineComponent({
  components: {},
  setup: function () {
    onMounted(() => {
    });

    return {};
  },
});
